import Vue from 'vue'
import VueRouter from 'vue-router'
import ManageView from '../views/ManageView.vue'
import store from "@/store";

Vue.use(VueRouter)

const routes = [
    // 登录路由
    {path: '/login', name: '登录', component: () => import('../views/Login.vue')},
    // demo路由
    {path: '/about', name: 'about', component: () => import('../views/AboutView.vue')},
    // 404路由
    {path: '/404', name: '404', component: () => import('../views/404.vue')},
    // test
    {path: '/test01', name: '测试01', component: () => import('../views/Test01.vue')},
    {path: '/test02', name: '测试02', component: () => import('../views/Test02.vue')},
    {path: '/test02', name: '测试02', component: () => import('../views/Test02.vue')},

]

// 创建路由实例，用于管理应用程序的路由。这个实例可以在 Vue 应用程序中使用，以便进行路由导航、监听路由变化等操作
// （在 Vue 应用程序中，通常会将这个 router 实例传递给根组件，以便在整个应用程序中使用路由功能）
const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 提供一个重置路由的方法
export const resetRouter = () => {
    router.matcher = new VueRouter({
        // mode: 'history',
        base: process.env.BASE_URL,
        routes
    })
}

// 设置动态路由的方法
// 注意：刷新路由会导致动态路由信息重置为空！！！！！解决办法在方法里面和下面
export const setRouters = () => {
    // 1.从浏览器内存取出角色的权限信息集合 JSON数据
    const storeMenus = localStorage.getItem("menus")
    // 2.是否有权限信息
    if (storeMenus) {
        // ！！获取全局路由对象数组！！
        const currentRouterNames = router.getRoutes().map(v => v.name)
        // ！！除了默认的‘login’等，不包含 “动态路由集合对象” 才要把 “动态路由集合对象” 添加到系统的路由对象中！！
        if (!currentRouterNames.includes("Manage")) {
            // 2.1 定义 “动态路由集合对象”
            const manageMenu = {
                path: '/', name: 'Manage', component: ManageView, redirect: '/home', children: [
                    {path: 'showUserInfo', name: '个人信息', component: () => import('../views/ShowUserInfo.vue')},
                    // {path: 'emp', name: '员工管理', component: () => import('../views/Emp.vue')},
                    // {path: '/creden', name: '证件管理', component: () => import('../views/Creden.vue')},
                    // {path: '/dept', name: '部门管理', component: () => import('../views/Dept.vue')},
                    // {path: '/post', name: '岗位管理', component: () => import('../views/Post.vue')},
                    // {path: '/duty', name: '职务管理', component: () => import('../views/Duty.vue')},
                    // {path: '/empNature', name: '员工性质管理', component: () => import('../views/EmpNature.vue')},
                    // {path: '/approvalGoodsInfo', name: '申购单', component: () => import('../views/ApprovalGoodsInfo.vue')},
                    // {path: '/approvalGoodsTodo', name: '代办', component: () => import('../views/ApprovalGoodsTodo.vue')},
                    // {path: '/receipt', name: '收据管理', component: () => import('../views/Receipt.vue')},
                    {path: '/approvalFinanceDetail', name: '申购报销详情', component: () => import('../views/ApprovalFinanceDetail.vue')},
                    {path: '/approvalFinanceAllDetail', name: '申购报销详情', component: () => import('../views/ApprovalFinanceAllDetail.vue')},
                ]
            }
            // 2.2 将浏览器获取的权限集合的JSON数据解析出来
            const menus = JSON.parse(storeMenus)
            // 2.3 遍历权限集合
            menus.forEach(item => {
                // 2.4.1 如果直接有path，类似首页”/“，就可以直接将该权限信息解析出来添加进 ”动态路由集合对象“ 中
                if (item.path) {
                    // 2.4.2 解析权限的路由信息，path的“/”不能重复，要去掉
                    let itemMenu = {
                        path: item.path.replace("/", ""),
                        name: item.name,
                        component: () => import('../views/' + item.pagePath + '.vue')
                    }
                    // 2.4.3 将解析出来的路由信息添加到 “动态路由路由集合对象” 中。都是直接放主路由”Manage“的children里，因为路由在”Manage“里没有层级关系。
                    manageMenu.children.push(itemMenu)
                    // 2.5.1 否则就是类似 “系统管理”，没有path，只有children，需要递归解析
                } else if (item.children.length > 0) {
                    item.children.forEach(item => {
                        if (item.path) {
                            let itemMenu = {
                                path: item.path.replace("/", ""),
                                name: item.name,
                                component: () => import('../views/' + item.pagePath + '.vue')
                            }
                            manageMenu.children.push(itemMenu)
                        }
                    })
                }
            })
            // 3.将 “动态路由集合对象” 添加到系统的路由对象中
            router.addRoute(manageMenu)
        }
    }
}

// ！！刷新网页会重置动态路由信息，需再次设置路由！！
setRouters()


// 解决重复路由报错问题
const originaPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originaPush.call(this, location).catch(err => err)
}

// 当发生路由导航时，beforeEach导航守卫会被触发!!!!!
// to参数代表即将进入的路由对象。
// from参数代表即将离开的路由对象。
// next函数是一个必须调用的回调函数，用于继续路由导航。
//
// 在每次路由导航之前，使用localStorage.setItem()将当前路径的名称存储在localStorage中。
// 调用store.commit("setPath")来触发setPath mutation，将currentPathName更新为localStorage中存储的当前路径名称。
// 最后，调用next()函数继续路由导航。
router.beforeEach((to, from, next) => {
    localStorage.setItem("currentPathName", to.name)
    store.commit("setPath")

    // 未找到路由，1.未登录 2.没有该路由 3.没有该路由权限
    if (!to.matched.length) {
        // 获取浏览器的"menus"，判断是否有值
        const storeMenu = localStorage.getItem("menus")
        // 有值，但没有匹配到路由，说明没有该路由权限或者系统没有该路由
        if (storeMenu && storeMenu !== "[]") {
            next("/404")
        } else { // 没值，说明没有登录
            next("/login")
        }
    }
    // 其他情况都放行
    next()
})

export default router
